import { render, staticRenderFns } from "./DrawingRequestShowAttachments.vue?vue&type=template&id=2eb2d6ae&"
import script from "./DrawingRequestShowAttachments.vue?vue&type=script&lang=js&"
export * from "./DrawingRequestShowAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports